import { resolveRealtimePath } from './helper';

const auth = resolveRealtimePath('auth');
const adjustmentData = `${resolveRealtimePath('util')}/adjustmentData`;
const body = resolveRealtimePath('body');
const mail = resolveRealtimePath('mail');
const neck = resolveRealtimePath('neck');
const operators = resolveRealtimePath('operators');
const recordNumbers = resolveRealtimePath('recordNumbers');
const orderNumbers = `${resolveRealtimePath('recordNumbers')}/order`;
const router = `${resolveRealtimePath('router')}/steps`;
const settings = resolveRealtimePath('settings');
const util = resolveRealtimePath('util');

export default {
  adjustmentData,
  auth,
  body,
  mail,
  neck,
  operators,
  orderNumbers,
  recordNumbers,
  router,
  settings,
  util,
};
